/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `PENDING` - Pending
 * * `PROCESSING` - Processing
 * * `PROCESSED` - Processed
 * * `FAILED` - Failed
 * @export
 */
export const StatusC7eEnum = {
    Pending: 'PENDING',
    Processing: 'PROCESSING',
    Processed: 'PROCESSED',
    Failed: 'FAILED'
} as const;
export type StatusC7eEnum = typeof StatusC7eEnum[keyof typeof StatusC7eEnum];


export function instanceOfStatusC7eEnum(value: any): boolean {
    for (const key in StatusC7eEnum) {
        if (Object.prototype.hasOwnProperty.call(StatusC7eEnum, key)) {
            if (StatusC7eEnum[key as keyof typeof StatusC7eEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StatusC7eEnumFromJSON(json: any): StatusC7eEnum {
    return StatusC7eEnumFromJSONTyped(json, false);
}

export function StatusC7eEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatusC7eEnum {
    return json as StatusC7eEnum;
}

export function StatusC7eEnumToJSON(value?: StatusC7eEnum | null): any {
    return value as any;
}

export function StatusC7eEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): StatusC7eEnum {
    return value as StatusC7eEnum;
}

